import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import * as sidemenuConfig from '@unitedtraders/side-menu-microfrontend';
import { actions, AuthModalTab } from 'shared/actions/app';
import { useAuthenticationStatus } from 'shared/hooks/user';
import { KeycloakContext } from 'init/App';
import { isVisibleSelector } from './selectors';
import { root as configSelector } from 'shared/selectors/config';
import { Language } from 'shared/types/common';
import { useBetaVersionRedirect } from 'hooks/useBetaVersionRedirect';
import { useLoginWith2FARecomendation } from 'hooks/useLoginWith2FARecomendation';

import './index.scss';

interface Props {}

export const ExternalUserMenu: React.FC<Props> = () => {
  const isAuthorized = useAuthenticationStatus();

  const isVisible = useSelector(isVisibleSelector);

  const config = useSelector(configSelector);

  const dispatch = useDispatch();

  const {
    i18n: { language },
  } = useTranslation();

  const goTo = useBetaVersionRedirect();

  const showAuthModal = (tab: AuthModalTab) =>
    dispatch(actions.showAuthModal(tab, 'mainMenu', 'desktopMainMenuRegistration'));

  const keycloak = React.useContext(KeycloakContext)!;

  const location = useLocation();

  const { isRecomendationVisible, hideRecomendation } = useLoginWith2FARecomendation();

  const props: sidemenuConfig.Props = {
    navigationActiveItem: getActiveMenu(location.pathname),
    isAuthorized,
    locale: language,
    featureFlags: {},
    getTokens: () => keycloak.getTokens(),
    onLogin: () => showAuthModal('signin'),
    onLogout: () => dispatch(actions.logout()),
    onRegistration: () => showAuthModal('signup'),
    openDepositModal: () => dispatch(actions.showDepositModal({ value: 0, currency: 'USD' })),
    openWithdrawModal: () => dispatch(actions.showWithdrawModal()),
    setLocale: (locale) => dispatch(actions.changeLanguage(locale as Language)),
    isVisible,
    setIsVisible: (visible) => dispatch(actions.toggleSidemenu(visible)),
    openLangModal: () => dispatch(actions.changeLanguage('en')),
    navigateTo: goTo,

    // @ts-ignore
    appConfig: {
      graphqlGateway: {
        url: config.graphqlGateway.url,
      },
      utPassport: {
        url: config.utPassportUrl,
      },
      utFeed: {
        url: config.feedUrl,
      },
    },

    // @ts-ignore
    loginWith2FARecomendation: {
      isVisible: isRecomendationVisible,
      hide: hideRecomendation,
    },
  };

  return (
    <div className="sidemenu-external">
      <Parcel config={sidemenuConfig} mountParcel={mountRootParcel} {...props} />
    </div>
  );
};

function getActiveMenu(pathname: string): sidemenuConfig.Props['navigationActiveItem'] {
  if (pathname.startsWith('/investments/open-investment')) {
    return 'portfolio';
  }

  if (pathname.startsWith('/investments')) {
    return 'ideas';
  }

  if (pathname.startsWith('/how-it-works')) {
    return 'howItWorks';
  }

  if (pathname.startsWith('/account')) {
    return 'account';
  }

  if (pathname === '/profile') {
    return 'passport';
  }

  return;
}
